// Stock Item Actions
// Similar to productActions.js, but for stock items 
import { createAsyncThunk } from '@reduxjs/toolkit';
import stockItemApi from '../../utils/api/stockItemApi';

export const fetchStockItems = createAsyncThunk(
  'stockItems/fetchStockItems',
  async (params) => {
    const response = await stockItemApi.getStockItems(params);
    return response;
  }
);

export const fetchStockItemById = createAsyncThunk(
  'stockItems/fetchStockItemById',
  async ({ params }) => {
    const response = await stockItemApi.getStockItem( params);
    return response;
  }
);

export const createStockItem = createAsyncThunk(
  'stockItems/createStockItem',
  async (item) => {
    const response = await stockItemApi.addStockItem(item);
    return response;
  }
);

export const updateExistingStockItem = createAsyncThunk(
  'stockItems/updateExistingStockItem',
  async ({ itemId, item }) => {
    const response = await stockItemApi.updateStockItem(itemId, item);
    return response;
  }
);

export const removeStockItem = createAsyncThunk(
  'stockItems/removeStockItem',
  async (itemId) => {
    const response = await stockItemApi.deleteStockItem(itemId);
    return response;
  }
);
